import { keyframes } from '@mui/system';

const shadowPulse = keyframes`
    0% { box-shadow: 0 0 0 0 rgba(252, 75, 88, 0.4); }
    70% { box-shadow: 0 0 0 10px rgba(220, 205, 20555, 0); }
    100% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); }
`;

export const pulseAnimationStyle = {
    animation: `${shadowPulse} 2s infinite`, borderRadius: '50%'
};
